// usage = diffArrays(a, b, 'id');
const arrToObj = (arr, keyField) =>
  arr.reduce((obj, item) => {
    obj[item[`${keyField}`.trim()]] = item;
    return obj;
  }, {});

export const diffArrays = (arr1, arr2, byField) => {
  const diff = [];
  const obj1 = arrToObj(arr1, byField);
  const obj2 = arrToObj(arr2, byField);
  for (const prop of arr1) {
    const idField = prop[byField];
    if (!obj2[idField]) diff.push(obj1[idField]);
  }
  return diff.length === 1 ? diff[0] : null;
};
